import React from 'react'
import './header.css'
import PersonIcon from '@material-ui/icons/Person';
import IconButton from "@material-ui/core/IconButton"
import ForumIcon from "@material-ui/icons/Forum"

function Header() {
    return (
        <div className="header">
{/* -----------------profile icon--------------- */}
            <IconButton>

                <PersonIcon fontSize="large" className="header__icon" />

            </IconButton>
{/* -----------------tinder icon-------------------- */}
            <img className="header__logo" src="https://img.icons8.com/fluent/48/000000/--tinder.png" />
{/* -------------------Forum button---------------- */}
            <IconButton>
                
                <ForumIcon fontSize="large" className="header__icon" />

            </IconButton>
        </div>
    )
}

export default Header
